module.exports = __webpack_public_path__ + "img/车前子.968a7ac0.jpg";